import { domToCanvas } from 'modern-screenshot';

/** Узлы виджета не попадают в снимок. */
export const FEEDBACK_IGNORE_ATTR = 'data-feedback-ignore';

export interface Shot {
  readonly blob: Blob;
  readonly url: string;
  readonly width: number;
  readonly height: number;
}

export interface Area {
  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
}

const MAX_BYTES = 5 * 1024 * 1024;

const toBlob = (canvas: HTMLCanvasElement, type: string, quality?: number) =>
  new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, type, quality);
  });

/** Снимок выделенной области окна (координаты окна, CSS-пиксели). */
export async function captureArea(area: Area): Promise<Shot> {
  const scale = Math.min(window.devicePixelRatio || 1, 2);
  const page = await domToCanvas(document.body, {
    scale,
    backgroundColor: getComputedStyle(document.body).backgroundColor || '#ffffff',
    filter: (node) => !(node instanceof Element && node.hasAttribute(FEEDBACK_IGNORE_ATTR)),
  });
  const width = Math.max(1, Math.round(area.width * scale));
  const height = Math.max(1, Math.round(area.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('canvas');
  ctx.drawImage(
    page,
    Math.round((area.x + window.scrollX) * scale),
    Math.round((area.y + window.scrollY) * scale),
    width,
    height,
    0,
    0,
    width,
    height,
  );
  let blob = await toBlob(canvas, 'image/png');
  if (!blob || blob.size > MAX_BYTES) blob = await toBlob(canvas, 'image/jpeg', 0.85);
  if (!blob) throw new Error('blob');
  return {
    blob,
    url: URL.createObjectURL(blob),
    width: Math.round(area.width),
    height: Math.round(area.height),
  };
}
